import { call, put, takeLatest } from 'redux-saga/effects';

import { TvLocationResponse, TvLocationScreen, TvResponse, TvScreen } from 'entities/TvRender/interfaces';
import { TvRender } from '../../../../entities/TvRender/services';
import { getTvDataError, getTvDataSuccess } from './actions';
import { GET_TV_DATA_REQUEST } from './constants';

function* getTVdata() {
  const branchLocal = localStorage.getItem('branchId') || 'null';
  const branchId = JSON.parse(branchLocal)?.id;
  try {
    let data: TvResponse;

    try {
      data = yield call(TvRender.getTvRender, branchId);
    } catch (error1: any) {
      // eslint-disable-next-line no-console
      console.log('Error 1 calling TvRender.getTvRender', error1);
      try {
        data = yield call(TvRender.getTvRender, branchId);
      } catch (error2: any) {
        // eslint-disable-next-line no-console
        console.log('Error 2 calling TvRender.getTvRender', error2);
        try {
          data = yield call(TvRender.getTvRender, branchId);
        } catch (error3: any) {
          // eslint-disable-next-line no-console
          console.log('Error 3 calling TvRender.getTvRender', error3);

          data = yield call(TvRender.getTvRender, branchId);
        }
      }
    }

    const { locations, customScreens } = data;

    const pauseResponse: TvLocationResponse | null = locations.find((f) => f.locationId === 0) || null;
    const pauseData: TvLocationScreen | null =
      pauseResponse !== null ? { ...pauseResponse, type: 'location' as const } : null;

    const filteredLocations = locations.filter((f) => f.locationId !== 0 && f.licensePlates.length > 0);
    const isQueueEmpty = filteredLocations.length === 0;
    const prepareData: TvScreen[] = [
      ...filteredLocations.map((item) => ({ ...item, type: 'location' as const })),
      ...(!isQueueEmpty ? customScreens?.map((item) => ({ imageUrl: item, type: 'custom' as const })) ?? [] : []),
    ];

    const currentScreen = prepareData[0] || pauseData;
    yield put(getTvDataSuccess(data, prepareData, currentScreen, pauseData));
  } catch (error: any) {
    yield put(getTvDataError(error));
  }
}

export function* panelSagaWatcher() {
  yield takeLatest(GET_TV_DATA_REQUEST, getTVdata);
}
